import { useQuery } from 'react-query';
import axios from 'helpers/axios/axios';
import config from 'Config';
import { ProductData, UseGetProductDataType } from '../useGetProduct/types';
import { useAuth0 } from '../Auth0/Auth0';
import { useSessionContext } from '../../contexts/sessionProvider/SessionProvider';

interface UseGetProductDataProps {
  productId?: string
  promoCode?: string,
  activationCode?: string,
  paymentSchedule?: string,
  useLegacy?: boolean,
  useAnnual?: boolean,
  enabled?: boolean
}

export const useGetProductData =
  ({
    productId,
    promoCode,
    activationCode,
    paymentSchedule,
    useLegacy: useLegacyProp,
    useAnnual: useAnnualProp,
    enabled: enabledProp = true
  }: UseGetProductDataProps): UseGetProductDataType => {
    const { isLoading: isAuth0Loading } = useAuth0();
    const { useLegacy, isAnnualRoute } = useSessionContext();
    const finalUseLegacy = useLegacyProp !== undefined ? useLegacyProp : useLegacy;
    const finalUseAnnual = useAnnualProp !== undefined ? useAnnualProp : isAnnualRoute;
    const searchParams = new URLSearchParams({
      ...(productId && { productId }),
      ...(promoCode && { promoCode }),
      ...(activationCode && { activationCode }),
      ...(paymentSchedule && { paymentSchedule }),
      ...(finalUseLegacy && { useLegacy: 'true' }),
      ...(finalUseAnnual && { useAnnual: 'true' })
    });
    const presentmentUrl = `${config.API_PRODUCT_PRICE_ENDPOINT}?${searchParams.toString()}`;
    const {
      isLoading: isProductDataLoading, isError, data, isSuccess
    } = useQuery(
      ['productData', activationCode || promoCode, activationCode || productId, paymentSchedule, finalUseLegacy],
      () => axios.get(presentmentUrl),
      {
        enabled:
        enabledProp &&
          !isAuth0Loading &&
          (Boolean(productId) || Boolean(activationCode)) &&
          finalUseLegacy !== undefined,
        retry: false,
        staleTime: 1000 * 60 * 5 // 5 minutes
      }
    );

    const isLoading = isProductDataLoading || isAuth0Loading;
    const productData = data?.data || {} as ProductData;
    return {
      productData, isLoading, isError, isSuccess
    };
  };

